import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Footer } from '../components/FooterCTA';
import useCMS from '../hooks/useCMS';
import useReveal from '../hooks/useReveal';
import { useI18n } from '../i18n/I18nProvider';

function LegalPage({ sectionKey, titleKey }) {
  const { t } = useI18n();
  const { cms, loading } = useCMS();
  useReveal();
  const data = cms?.[sectionKey];
  const title = data?.title || t(titleKey);
  const lastUpdated = data?.last_updated || '';
  const sections = data?.sections || [];

  return (
    <>
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <div className="reveal">
            <Link to="/" className="text-sm text-[#76B828] font-medium hover:underline">{t('legal.back')}</Link>
            <h1 className="font-display text-3xl sm:text-4xl mt-4 text-[#0b0b0f]">{title}</h1>
            {lastUpdated && <p className="text-[#8b8b95] text-sm mt-2">{t('legal.lastUpdated', '', { date: lastUpdated })}</p>}
          </div>

          {loading && !data ? (
            <div className="mt-12 text-center text-[#8b8b95]">{t('legal.loading')}</div>
          ) : sections.length === 0 ? (
            <div className="mt-12 text-center text-[#8b8b95]">{t('legal.empty')}</div>
          ) : (
            <div className="mt-10 space-y-8">
              {sections.map((s, i) => (
                <div key={i} className="reveal" style={{ transitionDelay: `${i * 50}ms` }}>
                  <h2 className="font-display text-xl text-[#0b0b0f]">{s.heading}</h2>
                  <p className="text-[#55555f] mt-2 leading-relaxed text-[15px]">{s.body}</p>
                </div>
              ))}
            </div>
          )}

          <div className="mt-16 pt-8 border-t border-black/10 reveal">
            <p className="text-sm text-[#8b8b95]">
              {t('legal.contactLine')}{' '}
              <a href="mailto:hello@wearebookers.com" className="text-[#76B828] hover:underline">hello@wearebookers.com</a>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export function TermsPage() {
  return <LegalPage sectionKey="legal_terms" titleKey="legal.termsTitle" />;
}

export function PrivacyPage() {
  return <LegalPage sectionKey="legal_privacy" titleKey="legal.privacyTitle" />;
}

export function CookiePolicyPage() {
  return <LegalPage sectionKey="legal_cookies" titleKey="legal.cookiesTitle" />;
}
